module.exports = __webpack_public_path__ + "img/arc.fdb32de5.png";